import { cn } from '@/lib/utils'
import { Button } from '../base/button'

interface GroupRadioToolbarProps {
  groups: { key: string; label: string }[]
  activeKey: string
  onChange: (key: string) => void
}

// Pill-style radio pair used for top-level selectors (e.g. Physical /
// Technical above reporting tables). Matches the Figma "RadioButton"
// component — detached pills with a radio circle, not a joined toggle
// group.
export function GroupRadioToolbar({
  groups,
  activeKey,
  onChange
}: GroupRadioToolbarProps) {
  return (
    <div className='flex items-center gap-2'>
      {groups.map((g) => {
        const selected = activeKey === g.key
        return (
          <Button
            key={g.key}
            type='button'
            variant='outline'
            onClick={() => onChange(g.key)}
            className={cn(
              'h-9 gap-3 rounded-lg px-4 text-sm font-medium',
              selected
                ? 'border-primary bg-primary/5 text-foreground hover:bg-primary/5'
                : 'border-border bg-card text-foreground hover:bg-secondary/40'
            )}
          >
            <span
              className={cn(
                'flex h-4 w-4 items-center justify-center rounded-full border',
                selected ? 'border-primary bg-input' : 'border-border bg-input'
              )}
            >
              {selected && <span className='bg-primary h-2 w-2 rounded-full' />}
            </span>
            {g.label}
          </Button>
        )
      })}
    </div>
  )
}
